/**
 * File: contractConstants.ts
 * Path: packages/config/src/contracts/contractConstants.ts
 * Description: IDK Solutions as a contracting party, and the limits the
 * signing flow runs on.
 */

import { BUSINESS_CONTACT } from "../voice/contact";

/**
 * IDK Solutions as it appears on every contract.
 *
 * The registration number is K2022757534. Liam's Word templates printed
 * "K20227575343" (a stray 3), corrected 1 Oct 2026. Contracts give the admin
 * mailbox, not a personal one, and the phone number from BUSINESS_CONTACT.
 */
export const CONTRACT_PROVIDER = {
  legalName: "IDK SOLUTIONS (PTY) LTD.",
  registrationNo: "K2022757534",
  address: "30 Pintail Crescent, Cape Town, Western Cape, 7800, South Africa",
  email: BUSINESS_CONTACT.email,
  phone: BUSINESS_CONTACT.phone,
} as const;

/** Who countersigns when the settings document says nothing. */
export const DEFAULT_CONTRACT_SIGNATORY = "Liam Daries";

/** A signing link works this long after it is sent. */
export const SIGNING_LINK_TTL_DAYS = 14;
/** A link to the signed copy works this long. */
export const COPY_LINK_TTL_DAYS = 30;
/** A drawn signature PNG larger than this is refused. */
export const SIGNATURE_MAX_BYTES = 300 * 1024;

/** Firestore and Storage names. */
export const CONTRACT_COLLECTIONS = {
  contracts: "contracts",
  /** Server-only: one document per issued link, keyed by the token's SHA-256. */
  links: "contractLinks",
  /** Admin-only settings: contractSettings/payment. */
  settings: "contractSettings",
  /** Server-written audit trail under each contract. */
  events: "events",
  /** Staff-recorded payments under each contract, one per payment reference. */
  receipts: "receipts",
  /** Due dates set by hand on payments, one per payment reference. */
  dueDates: "dueDates",
  /** Server-written: which books invoice a brought-in contract's payment was billed on. */
  invoiceLinks: "invoiceLinks",
  /** One create-only line per WhatsApp reminder sent for a late payment. */
  reminders: "paymentReminders",
} as const;

export const CONTRACT_SETTINGS_DOC = "payment";

/** Cloud Storage folder for signatures and rendered PDFs (server-only). */
export const CONTRACT_STORAGE_PREFIX = "contracts";
